import * as types from './mutation-types'
import * as currencyTypes from '../currency/mutation-types'
export const loadData = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/super/admin/dashboard`, { params }).then((response) => {
      commit(types.SET_INITIAL_DATA, response.data)
      commit(types.GET_INITIAL_DATA, true)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const panelInformation = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
   
    window.axios.get(`/api/super/admin/panelInformation`, { params }).then((response) => {
      commit(types.SET_INITIAL_DATA, response.data)
      commit(types.GET_INITIAL_DATA, true)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

